import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PlaceModel, PlaceService } from '../place';
import { instanceToInstance } from 'class-transformer';

@Component({
  selector: 'app-place-dialog',
  templateUrl: './place-dialog.component.html',
  styleUrls: ['./place-dialog.component.scss']
})
export class PlaceDialogComponent implements OnInit {

  public isEditDialog = false;
  public inProgress: boolean = false;
  public unchangedData: PlaceModel;

  constructor(
    public dialogRef: MatDialogRef<PlaceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PlaceModel,
    private placeService: PlaceService) {
    if (data._id) {
      this.isEditDialog = true;
      this.unchangedData = instanceToInstance(data);
    }
  }

  ngOnInit(): void {
  }

  abort(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (this.isEditDialog && this.hasDataChanged()) {
      this.inProgress = true;
      this.placeService.update(this.data).subscribe(
        (res) => { },
        (err) => { },
        () => {
          this.inProgress = false;
          this.dialogRef.close(this.data);
        }
      );
    } else {
      this.dialogRef.close(this.data);
    }
  }

  hasDataChanged(): boolean {
    return (JSON.stringify(this.unchangedData) !== JSON.stringify(this.data));
  }


}
